const currencyFormats = {
  USD: { style: "currency", currency: "USD", currencyDisplay: "narrowSymbol" }
};
export {
  currencyFormats
};
//# sourceMappingURL=config.js.map
